import { useAuth } from 'context/AuthProvider'
import { Navigate } from 'react-router-dom'

export default function RedirectUser() {
  const { user } = useAuth()

  if (!user) return null

  return <Navigate to={user.id.toString()} />
}
